import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[rrShowTooltip]',
})
export class ShowTooltipDirective {
  @Output()
  public hover: EventEmitter<ElementRef> = new EventEmitter();

  @HostListener('mouseover')
  onMouseOver() {
    this.hover.emit(this._elementRef);
  }

  constructor(private _elementRef: ElementRef, private _renderer: Renderer2) {}
}
